<template>
  <div class="c-smart-video">
    <Row class="row-item" :gutter="12">
      <Col span="4" class="col-item">
        <span class="item-field">{{ description }}({{ len }}/{{ max }})</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="type" type="button">
          <Radio label="vertical">竖版视频{{ hlen ? `(${hlen})` : '' }}</Radio>
          <Radio label="horizontal">横版视频{{ vlen ? `(${vlen})` : '' }}</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <Row class="row-item" :gutter="12">
      <Col span="4" class="col-item">
        <span class="item-field">&nbsp;</span>
      </Col>
      <Col span="20" class="row-warp">
        <div v-if="msg" class="c-col-msg">
          <span>{{ msg }}</span>
        </div>
        <smart-item v-for="item of views" :key="item.id" :class="{ 'c-check-mark': checkMark(item) }" closable @close="delView(item)">
          <Icon type="md-checkmark-circle-outline" size="18" @click="$emit('select', item)" />
          <div class="video-row">
            <creat-video
              v-model="item[item.name]"
              :name="item.name"
              :mode="item.element"
              :width="item.restriction.width"
              :height="item.restriction.height"
              :size="item.restriction.file_size"
              :format="item.restriction.file_format"
              :required="item.required"
              :description="item.description"
              :verify="verify"
              :source="source"
              :scene-id="sceneId"
              :local="local"
              @select="select(...arguments, item.id)"
            />

            <creat-image
              v-model="item['cover']"
              name="cover"
              mode="ELEMENT_TYPE_COVER"
              :width="item.name === 'vertical' ? 720 : 1280"
              :height="item.name === 'vertical' ? 1280 : 720"
              :size="2048"
              :format="['IMAGE_JPG']"
              :required="true"
              :description="'封面'"
              :verify="verify"
              :source="source"
              :scene-id="sceneId"
              :local="local"
              @select="select(...arguments, item.id)"
            />
          </div>
        </smart-item>
        <smart-item>
          <upload-button v-if="len !== max" @on-click="$emit('on-add', { type, len: max - len })">
            <span>选择视频</span>
          </upload-button>
        </smart-item>
      </Col>
    </Row>

    <Row class="row-item" :gutter="12">
      <Col span="4" class="col-item">
        <span class="item-field">智能抽帧</span>
      </Col>
      <Col span="12">
        <i-switch v-model="smartCoverModel" :true-value="1" :false-value="0"></i-switch>
      </Col>
    </Row>
  </div>
</template>
<script>
import CreatVideo from './creat-video'
import CreatImage from './creat-image'
import UploadButton from './upload-button'
import SmartItem from './smart-item'
export default {
  name: 'smartVideo',
  components: { CreatVideo, UploadButton, CreatImage, SmartItem },
  props: {
    value: {
      type: [Number, String]
    },
    description: {
      type: String,
      default: ''
    },
    data: {
      type: Array
    },
    max: {
      type: Number,
      default: 5
    },
    sceneId: {
      type: Number
    },
    source: {
      type: Array
    },
    verify: {
      type: Boolean
    },
    required: {
      type: Boolean
    },
    local: {
      type: Boolean,
      default: false
    },
    smartCover: {
      type: Number,
      default: 0
    }
  },
  computed: {
    smartCoverModel: {
      get() {
        return this.smartCover
      },
      set(v) {
        this.$emit('smart-change', v)
      }
    },
    views() {
      return this.data.map((ret, id) => Object.assign(ret, { id })).filter((ret) => ret.name === this.type)
    },
    len() {
      return this.data.length
    },
    vlen() {
      return this.data.filter((ret) => ret.name === 'horizontal').length
    },
    hlen() {
      return this.data.filter((ret) => ret.name === 'vertical').length
    },
    checkMark() {
      return (item) => item[item.name] === this.value
    },
    msg() {
      return this.verify && this.required && !this.len ? `${this.description}不能为空` : ''
    }
  },
  data() {
    return {
      type: 'vertical'
    }
  },
  methods: {
    delView(item) {
      const { name, id } = item
      if (this.value === item[name]) this.$emit('on-clear')
      this.$emit('on-delete', id)
    },
    select() {
      const param = arguments[0]
      const index = arguments[1]
      this.$emit('on-select', { param, index })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-smart-video {
  position: relative;

  .c-item-block {
    padding: 20px 0;
  }

  .c-check-mark {
    .video-row {
      border-color: #1890ff !important;
    }

    .ivu-icon {
      color: #1890ff;
    }
  }

  .row-warp {
    position: relative;
    display: flex;
    overflow: auto;
    ::v-deep .video-row {
      display: flex;
      border: 2px solid transparent;
      .c-image {
        padding-bottom: 0;
        margin-left: 3px;
        .c-col-msg {
          bottom: -15px;
        }
      }
      .c-video {
        box-sizing: content-box;
        padding-bottom: 0;
      }
    }
  }

  .ivu-icon {
    color: #dbdbdb;
    top: 2px;
  }

  .c-col-msg {
    position: absolute;
    z-index: 4;
    left: 0;
    bottom: -18px;
    color: #ff4400;
  }
}
</style>
